
export const documentTitle = (pageTitle) => {
    return `${pageTitle} — Моды для Мир танков`
}